export default function (state = "", action) {
  const type = `${action.type}`
  if (action.payload != undefined) {
    return Object.assign({}, state, {
        [type] : action.payload
    });
  }else{
    return state;
  }
}
